
import type { PropOptions } from 'vue';
import Vue from 'vue';
import EmptyListIcon from './assets/empty-list.vue.svg';

export default Vue.extend({
  name: 'EmptyTestimonialsPlaceholder',
  components: { EmptyListIcon },
  props: {
    linkText: {
      type: String,
      default: '',
    } as PropOptions<string>,
  },
});
